import type { DocumentRepository } from "../repositories/document-repository"

export const makeUploadDocuments = (repo: DocumentRepository) =>
  (params: { kbId: string; files: File[] }) =>
    repo.upload(params)
